import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'degreesFromSeconds'})
export class DegreesFromSecondsPipe implements PipeTransform {

  transform(seconds: string): string {

    let secLen = seconds.length;
	let calc = parseFloat(seconds);
	calc = calc / 3600;
	if (seconds.substr(secLen -1, 1) == 'W' || seconds.substr(secLen -1, 1) == 'S')
	    calc = calc * -1;
    
    if(isNaN(calc)){
    		calc=0;
    }
    	  
    return calc.toString();
  }
}


/** WEBPACK FOOTER **
 ** ./app/airports/degrees-from-seconds.pipe.ts
 **/